import { UploadError } from '../../errors';
import type { UploaderChunkState } from '../../state';

export class B2EmptyChunkHashError extends UploadError {
  chunk: UploaderChunkState<unknown>;

  constructor(chunk: UploaderChunkState<unknown>) {
    super(`Chunk ${chunk.index} sha1 hash is empty`);
    this.chunk = chunk;
  }
}

export class B2NonMultiMetaError extends UploadError {}

export class B2UnsupportedError extends UploadError {
  constructor() {
    super('B2 multipart uploads are not supported for this upload kind');
  }
}

export class B2NonSingleMetaError extends UploadError {}
